module.exports = __webpack_public_path__ + "static/img/en_US2.8f29dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en_US2.png
// module id = 9Tsb
// module chunks = 1